import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en/translation.json';
import tr from '../locales/tr/translation.json';
import ja from '../locales/ja/translation.json';

// i18n initialization with browser language detection
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      ja: { translation: ja },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'tr', 'ja'],
    detection: {
      // Query string > localStorage > cookie > navigator > htmlTag
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Keep <html lang="..."> in sync with current language
i18n.on('initialized', () => {
  if (document?.documentElement) {
    document.documentElement.setAttribute('lang', i18n.language || 'en');
  }
});

i18n.on('languageChanged', (lng) => {
  if (document?.documentElement && lng) {
    document.documentElement.setAttribute('lang', lng);
  }
});

export default i18n;

